import { FeedbackSummaryState } from '@modules/oracle/feedbackSummaryStore/types';

export const feedbackSummaryInitialState: FeedbackSummaryState = {
  data: {
    messages: [],
    userQuotesByExampleID: {},
    userQuoteTokensByResponseID: {},
    sessionID: null,
  },
  visual: {
    isCompleted: false,
    dislikeSet: new Set(),
    likeSet: new Set(),
    error: undefined,
    shouldRejectIncomingMessages: false,
  },
};
